/* @jsxImportSource @emotion/react */
import React from 'react';
import { observer } from 'mobx-react';
import { Container } from './styled';
import UseButton from '@/components/commonComps/Use/UseButton';
import { getAppSystemList } from '../Common/method';
import { usePush } from '../Common/hook';
import { Image } from 'antd-mobile';

const Page = () => {
  const { pushUrl } = usePush();
  return (
    <Container>
      {getAppSystemList().map((item, index) => {
        return (
          <div
            key={index}
            onClick={() => {
              localStorage.setItem('selectSubSystemCode', item.code || '');
              pushUrl();
            }}>
            <Image src={(item?.phoneEntryUrl || '') + (item.icon || '')} />
          </div>
        );
      })}
    </Container>
  );
};
export default observer(Page);
